/* eslint-disable max-lines */
/***
 * Formato de literales: [pantalla]_[lineral]
 */
export const strings = {
  splash_title: 'Bienvenidos a la nueva app de EMT Palma',
  lb_ca: 'Català',
  lb_es: 'Castellano',
  lb_en: 'English',
  lb_de: 'Deutsch',
  iniciar_sesion: 'Iniciar sesión',
  lb_aceptar: 'Aceptar',
  lb_cancelar: 'Cancelar',
  lb_cerrar: 'Cerrar',
  lb_agenda: 'Agenda',
  lb_museos: 'Museos',
  lb_monumentos: 'Monumentos',
  lb_rutas: 'Rutas',
  lb_bibliotecas: 'Bibliotecas',
  lb_playas: 'Playas',
  lb_centros_deportivos: 'Centros deportivos',
  lb_centros_educativos: 'Centros educativos',
  lb_listado_lineas: 'Listado de líneas',
  lb_casa: 'Casa',
  lb_trabajo: 'Trabajo',
  lb_colegio: 'Colegio',
  lb_deportes: 'Deportes',
  lb_busquedas_recientes: 'Búsquedas recientes',
  lb_busquedas_recientes_msg:
    'Busca una dirección o selecciona un punto en el mapa que te permita realizar una planificación.',
  lb_parada_destino: 'Parada o destino',
  lb_lineas_horarios: 'Líneas y horarios',
  lb_lineas_horarios_bus: 'Líneas y horarios de bus',
  lb_alteraciones_servicio: 'Todas las alteraciones del servicio',
  lb_conoce_nuestra_red_transporte: 'Conoce nuestra red de transporte',
  lb_planificador: 'Planificador',
  lb_paradas: 'Paradas',
  lb_parada: 'Parada',
  lb_lineas: 'Líneas',
  lb_lineas_no_hay_horarios_disponibles: 'No hay horarios disponibles',
  lb_tarifas_tarjetas: 'Tarifas y tarjetas',
  lb_tarifas_recarga: 'Tarifas y recarga',
  lb_atencion_cliente: 'Atención al cliente',
  lb_emt_palma: 'EMT palma',
  lb_visita_palma: 'Visita Palma',
  lb_explorar: 'Explorar',
  lb_cargando: 'Cargando',
  lb_borrar_parada_error_msj: 'Error al borrar la parada. Por favor intentelo más tarde.',
  lb_agregar_parada_error_msj: 'Error al agregar la parada. Por favor intentelo más tarde.',
  lb_borrar_parada_exito_msj: 'Parada eliminada correctamente',
  lb_borrar_parada_exito_msj_secundario: 'Recibirás alertas de esta parada',
  lb_agregar_parada_exito_msj: 'Parada guardada correctamente.',
  lb_borrar_linea_error_msj: 'Error al borrar la línea. Por favor intentelo más tarde.',
  lb_agregar_linea_error_msj: 'Error al agregar la línea. Por favor intentelo más tarde.',
  lb_borrar_linea_exito_msj: 'Línea eliminada correctamente',
  lb_borrar_linea_exito_msj_secundario:
    'Recibirás notificaciones de esta línea cuando se le agreguen avisos',
  lb_agregar_linea_exito_msj: 'Línea agregada como favorita correctamente.',
  lb_borrar_poi_error_msj: 'Error al borrar el punto de interés. Por favor intentelo más tarde.',
  lb_agregar_poi_error_msj: 'Error al agregar el punto de interés. Por favor intentelo más tarde.',
  lb_borrar_poi_exito_msj: 'Punto de interés eliminado correctamente',
  lb_borrar_poi_exito_msj_secundario: 'Recibirás alertas de este punto de interés',
  lb_agregar_poi_exito_msj: 'Punto de interés agregado correctamente.',
  lb_borrar_destino_error_msj: 'Error al borrar destino. Por favor intentelo más tarde.',
  lb_agregar_destino_error_msj: 'Error al agregar destino. Por favor intentelo más tarde.',
  lb_borrar_destino_exito_msj: 'Destino eliminado correctamente',
  lb_borrar_destino_exito_msj_secundario: 'Recibirás alertas de este destino',
  lb_agregar_destino_exito_msj: 'Destino agregado correctamente.',
  lb_borrar_evento_error_msj: 'Error al borrar evento. Por favor intentelo más tarde.',
  lb_borrar_evento_exito_msj_secundario: 'Recibirás alertas de este evento',
  lb_agregar_evento_error_msj: 'Error al agregar evento. Por favor intentelo más tarde.',
  lb_borrar_evento_exito_msj: 'Evento eliminado correctamente',
  lb_agregar_evento_exito_msj: 'Evento agregado correctamente.',
  lb_msj_error_generico: 'Error al realizar la operación. Por favor intentelo más tarde.',
  lb_msj_exito_generico: 'Operación realizada correctamente.',
  lb_No_encontado: 'No se han encontrado resultados.',
  lb_explorer_lugares: 'Puntos red EMT',
  lb_explorer_transportes: 'Transportes',
  lb_explorer_paradas_lineas: 'Paradas y líneas',
  lb_explorer_filtros: 'Filtros',
  lb_explorer_filtros_deshacer: 'Deshacer',
  lb_explorer_detalle_parada: 'Detalle de parada',
  lb_avisos_descargar: 'Descargar pdf',
  lb_avisos_ampliar: 'Ampliar',
  lb_planner_donde_quieres_ir: '¿A dónde vamos?',
  lb_planner_origen: 'Origen',
  lb_planner_destino: 'Destino',
  lb_planner_seleccionar_mi_localizacion: 'Seleccionar mi localización',
  lb_planner_seleccionar_mi_posicion_mapa: 'Seleccionar una ubicación sobre el mapa',
  lb_planner_salir_en: 'Salir en:',
  lb_planner_minutos: 'minutos',
  lb_planner_no_especificar: 'Sin especificar',
  lb_planner_transbordo: 'transbordo',
  lb_planner_salir_ahora: 'Salir ahora',
  lb_planner_salir_a_las: 'Salir a las',
  lb_planner_llegar_a_las: 'Llegar a las',
  lb_planner_paradas: 'Paradas',
  lb_planner_mi_ubicacion: 'Mi ubicación',
  lb_planner_preferencias: 'Preferencias',
  lb_planner_preferencias_ordenar: 'Ordenar por',
  lb_planner_preferencias_parametros: 'Parámetros',
  lb_planner_preferencias_operadores: 'Operadores',
  lb_planner_preferencias_parking_disuasorio: 'Combinar coche con parking disuasorio',
  lb_planner_preferencias_accesibilidad_sillas: 'Accesibilidad para sillas de ruedas',
  lb_planner_preferencias_mas_rapida: 'Más rápida',
  lb_planner_preferencias_menos_trans: 'Menos transbordo',
  lb_planner_preferencias_caminar: 'Caminar menos',
  lb_planner_preferencias_caminar_max: 'Caminar máximo',
  lb_planner_preferencias_ruta_mas_rapida: 'Ruta más rápida',
  lb_favorites_paradas_guardadas: 'PARADAS GUARDADAS',
  lb_favorites_lineas_guardadas: 'LÍNEAS GUARDADAS',
  lb_favorites_eventos_guardadas: 'EVENTOS GUARDADOS',
  lb_favorites_destinos_guardadas: 'DESTINOS GUARDADOS',
  lb_Favoritos: 'Favoritos',
  lb_buscar: 'Buscar',
  lb_novedades: 'Noticias',
  lb_noticia_no_existe: 'Esta noticia ya no existe',
  lb_favorites_buscar_favorito: 'Buscar favorito',
  lb_favorites_buscar_lineas: 'Buscar líneas',
  lb_favorites_tab_paradas: 'Paradas',
  lb_favorites_tab_destinos: 'Lugares',
  lb_favorites_tab_lineas: 'Líneas',
  lb_favorites_tab_agenda: 'Agenda',
  lb_favorites_guarda_parada: 'Guarda una parada en favoritos',
  lb_favorites_anadir_casa: 'Añadir casa',
  lb_favorites_anadir_trabajo: 'Añadir trabajo',
  lb_favorites_ninguna_parada:
    'No tienes ninguna parada guardada en favoritos, añade aquellas que más uses y guárdalas para poder acceder de forma rápida.',
  lb_favorites_guarda_destino: 'Guarda un Lugar en favoritos',
  lb_favorites_ningun_destino:
    'No tienes ningún destino guardado en favoritos, añade aquellos que más uses y guárdalos para poder acceder de forma rápida.',
  lb_favorites_guarda_linea: 'Guarda una línea en favoritos',
  lb_favorites_ninguna_linea:
    'No tienes ninguna línea guardada en favoritos, añade aquellas que más uses y guárdalas para poder acceder de forma rápida.',
  lb_favorites_guarda_evento: 'Guarda un evento en favoritos',
  lb_favorites_ninguna_evento:
    'No tienes ningún evento guardado en favoritos, añade aquellos eventos de interés y guárdalos para poder acceder de forma rápida.',
  lb_favorites_seguro_eliminar_parada: 'Estás seguro que deseas eliminar la parada',
  lb_favorites_seguro_eliminar_line: 'Estás seguro que deseas eliminar la línea',
  lb_favorites_seguro_eliminar_destino: 'Estás seguro que deseas eliminar el destino',
  lb_favorites_seguro_eliminar_evento: 'Estás seguro que deseas eliminar el evento',
  lb_favorites_guardar_secondary:
    'Por favor, elige una categoría y un nombre. Si no eliges ninguno se guardará sin categorización.',
  lb_favorites_guardar_parada_interrogante: '¿Deseas guardar esta parada como favorita?',
  lb_favorites_guardar_parada_main:
    'Se guardará como “Paradas guardados” en la sección de favoritos.',
  lb_favorites_guardar_linea_interrogante: '¿Deseas guardar esta línea como favorita?',
  lb_favorites_guardar_linea_main:
    'Se guardará como “Líneas guardadas” en la sección de favoritos.',
  lb_favorites_guardar_evento_interrogante: '¿Deseas guardar este evento como favorito?',
  lb_favorites_guardar_evento_main:
    'Se guardará como “Eventos guardados” en la sección de favoritos.',
  lb_favorites_guardar_destino_interrogante: '¿Deseas guardar este destino como favorito?',
  lb_favorites_guardar_destino_main:
    'Se guardará como “Destinos guardados” en la sección de favoritos.',
  lb_configuracion_menu_gestionar_cuenta: 'Gestionar cuenta',
  lb_configuracion_menu: 'Menú',
  lb_configuracion_account: 'Mi cuenta',
  lb_configuracion_menu_idioma: 'Idioma',
  lb_configuracion_menu_avisos: 'Avisos',
  lb_configuracion_menu_favoritos: 'Favoritos',
  lb_configuracion_menu_ayuda: 'Ayuda y contacto',
  lb_configuracion_parada: 'Paso por parada',
  lb_info_contacto: 'Contacto EMT Palma',
  lb_oficina_atcliente_ayuntamiento_palma:
    'Oficina atención al cliente EMT Palma y Oficinas Atención a la Ciudadanía Ajuntament de Palma',
  lb_gestiones_tarjeta_ciudadana:
    'Para gestiones con la tarjeta ciudadana puede acudir a la Oficina de Atención al Ciudadano más cercana.',
  lb_oficina_palama_oac: 'Oficina EMT Palma u OAC',
  lb_configuracion_menu_tarifas: 'Tarifas',
  lb_configuracion_menu_punts: 'Mis puntos',
  lb_configuracion_menu_configuracion: 'Configuración',
  lb_configuracion_menu_notificaciones: 'Notificaciones',
  lb_configuracion_menu_terminos_privacidad: 'Términos y privacidad',
  lb_configuracion_menu_aviso_legal: 'Aviso legal',
  lb_configuracion_menu_eliminar_datos: 'Eliminar tus datos',
  lb_configuracion_recuperar_password: 'Recuperar contraseña',
  lb_configuracion_password: 'Contraseña',
  lb_configuracion_registrate_para_poder:
    'Regístrate para poder acceder a todas las funcionalidades.',
  lb_configuracion_crear_cuenta: 'Crear cuenta',
  lb_configuracion_repetir_password: 'Repetir contraseña',
  lb_configuracion_aceptar_terminos_condiciones: 'Aceptar términos y condiciones',
  lb_configuracion_alias: 'Alias',
  lb_configuracion_cerrar_sesion: 'Cerrar sesión',
  lb_configuracion_punto_cerrar_sesion: 'Estás a punto de cerrar sesión.',
  lb_configuracion_datos_modificados: 'Datos modificados',
  lb_configuracion_datos_guardados: 'Datos guardados correctamente',
  lb_configuracion_cuenta_creada: 'Cuenta creada correctamente',
  lb_sesion_no_iniciada: 'Regístrate o inicia sesión para acceder a todas las funcionalidades',
  lb_configuracion_inicia_sesion: 'Revise su bandeja de entrada para activar la cuenta.',
  lb_contrasena_minimo_caracteres: '6 caractéres mínimo',
  lb_contrasena_minimo_una_letra: 'Al menos una letra mayúscula y minúscula',
  lb_contrasena_minimo_un_numero: 'Al menos un número',
  lb_ambas_contrasenas_iguales: 'Ambas contraseñas deben ser iguales',
  lb_configuracion_datos_guardados_correctamente: 'Los datos se han guardado correctamente.',
  lb_configuracion_correo: 'Correo electrónico',
  lb_configuracion_informacion_personal: 'Información Personal',
  lb_configuracion_cambiar_contrasena: 'Cambiar contraseña',
  lb_configuracion_nueva_contrasena: 'Contraseña nueva',
  lb_configuracion_actual_contrasena: 'Contraseña actual',
  lb_configuracion_confirmar_contrasena: 'Confirmar contraseña',
  lb_configuracion_guardar_cambios: 'Guardar cambios',
  lb_configuracion_necesitas_contrasena_nueva: '¿Necesitas una contraseña nueva?',
  lb_configuracion_necesitas_contrasena_nueva_text:
    'Introduce el correo electrónico con el que te registraste',
  lb_configuracion_usuario_actualizado: 'Usuario actualizado correctamente',
  lb_configuracion_revisa_bandeja_correo: 'Revisa tu bandeja de entrada',
  lb_lineas_directorio_lineas: 'Líneas regulares',
  lb_lineas_busca_linea: 'Busca una línea',
  lb_lineas_visualizar_sentido: '¿Deseas visualizar un sentido?',
  lb_lineas_detalle_linea: 'Detalle de línea',
  lb_lineas_tab_linea: 'Línea',
  lb_lineas_tab_horarios: 'Horarios',
  lb_lineas_tab_avisos: 'Avisos',
  lb_lineas_a_las: 'a las',
  lb_home_cerca_mi: 'Explora',
  lb_home_avisos_alertas: 'Avisos',
  lb_ver_avisos: 'VER AVISOS',
  lb_home_saber_mas: 'Saber más',
  lb_home_consejos_informacion_novedades: 'Consejos e información',
  lb_error404_no_encontrada: 'Página no encontrada',
  lb_error500: 'Error inesperado',
  lb_volver_al_home: 'Ir al inicio',
  lb_avisos: 'Avisos generales',
  lb_mis_avisos: 'Mis avisos',
  lb_titulo_aviso: 'No hay avisos activos en este momento',
  lb_titulo_texto_favorito:
    'Se mostrarán todos los avisos activos para las paradas/líneas favoritas del usuario.',
  lb_titulo_texto:
    'Se mostrarán todos los avisos activos para las paradas y líneas de la EMT Palma.',
  lb_ruta_desde_esta_parada: 'Ruta desde esta parada',
  lb_seo_title_inicio: 'Inicio',
  lb_seo_default_description:
    'EMT Palma es la empresa municipal del Ayuntamiento de Palma que gestiona el transporte urbano colectivo de viajeros de la ciudad de Palma y alrededores.',
  lb_seo_description_inicio:
    'EMT Palma es la empresa municipal del Ayuntamiento de Palma que gestiona el transporte urbano colectivo de viajeros de la ciudad de Palma y alrededores.',
  lb_seo_title_planificador: 'Planificador de Rutas',
  lb_seo_description_planificador:
    'Planifica tu viaje con EMT Palma. Consulta rutas, tiempos y llegadas para llegar a tu destino en la red de transporte urbano de Palma.',
  lb_seo_title_paradas: 'Paradas y Puntos de Interés',
  lb_seo_description_paradas:
    'Explora las paradas de la red EMT, puntos de interés y oficinas de información en Palma. Encuentra rápidamente tu parada más cercana y sus conexiones.',
  lb_seo_title_lineas: 'Líneas',
  lb_seo_description_lineas:
    'Consulta todas las líneas de EMT Palma y sus itinerarios. Descubre las rutas de transporte público disponibles en la ciudad de Palma y alrededores.',
  lb_seo_title_tarifas: 'Tarifas de Transporte',
  lb_seo_description_tarifas:
    'Descubre las tarifas del transporte público en Palma, incluyendo billetes sencillos, abonos y otras opciones para moverse por la ciudad.',
  lb_seo_title_puntos_venta: 'Puntos de Venta',
  lb_seo_description_puntos_venta:
    'Encuentra los puntos de venta de billetes para el transporte público en Palma. Consulta ubicaciones de máquinas expendedoras y oficinas.',
  lb_seo_title_atencion_cliente: 'Atención al Cliente',
  lb_seo_description_atencion_cliente:
    'Consulta la información de contacto de EMT Palma y localiza las oficinas de atención al cliente en el mapa.',
  lb_seo_title_faq: 'FAQ',
  lb_seo_description_faq:
    'Resuelve tus dudas con nuestras preguntas frecuentes. Filtra por categorías y encuentra la información que necesitas sobre el transporte en Palma.',
  lb_seo_title_noticias: 'Noticias',
  lb_seo_description_noticias:
    'Mantente informado sobre las últimas noticias relacionadas con el transporte público en Palma de Mallorca.',
  lb_seo_title_favoritos: 'Favoritos',
  lb_seo_description_favoritos:
    'Accede a todos los elementos que has guardado como favoritos: paradas, puntos de interés o líneas de la red EMT Palma.',
  lb_seo_title_configuracion: 'Configuración',
  lb_seo_description_configuracion:
    'Personaliza la configuración de la web de EMT Palma. Administra tus favoritos, tarifas y selecciona el idioma de la plataforma.',
  lb_overlapping_lines_desc: 'líneas pasan por aquí',
  lb_overlapping_line1_desc: 'línea pasa por aquí',
  lb_ampliar: 'Ampliar',
  lb_noticias: 'Noticias',
  lb_noticia: 'Noticia',
  lb_noticias_novedades: 'Noticias y novedades',
  lb_oficina_atcliente: 'Oficina de atención al cliente EMT Palma',
  lb_horarios_atcliente: 'Horario de atención al cliente',
  lb_faqs: 'Preguntas frecuentes (FAQ)',
  lb_preguntas_frecuentes: 'Preguntas frecuentes',
  lb_buscar_contenido: 'Buscar contenido',
  lb_buscar_por_palabra_clave: 'Buscar por palabra clave',
  lb_muestran_resultados_para: 'Se muestran resultados para',
  lb_no_hay_coincidencias: 'No hay coincidencias',
  lb_punto_recarga_venta: 'Puntos de recarga y venta',
  lb_urbano: 'Urbano',
  lb_aeropuerto: 'Aeropuerto',
  lb_puerto: 'Puerto',
  lb_perfil: 'Perfil',
  lb_gratis: 'Gratis',
  lb_nota: 'Nota',
  lb_descargar_mas_informacion: 'Descargar más información',
  lb_advertencias: 'Advertencias',
  lb_referencias_legales: 'Referencias legales',
  lb_no_hay_datos_disponibles: 'No hay datos disponibles',
  lb_no_hay_avisos: 'No hay avisos',
  lb_ir: 'Ir',
  lb_favorito: 'Favorito',
  lb_alarma: 'Alarma',
  lb_horarios: 'Horarios',
  lb_refrescar: 'Actualizar',
  lb_accesibilidad: 'Accesibilidad',
  lb_filtra: 'Filtra',
  lb_paso_por_parada: 'Paso por parada',
  lb_maquinas_autoventas: 'Autoventa 24h',
  lb_puntos_ventas: 'Punto de recarga y venta',
  lb_oficina_atencion_cliente: 'Oficina Atención al Cliente EMT Palma',
  lb_oficina_emt: 'Oficina Atención Ciudadana',
  lb_eliminar_mis_datos: 'Eliminar mis datos',
  lb_cuenta_eliminada: 'Cuenta eliminada correctamente',
  lb_publicado_el: 'Publicado el',
  lb_desde_el: 'A partir del:',
  lb_hasta_el: 'Final:',
  lb_ver_todos_itinerarios: 'Ver todos los itinerarios',
  lb_reclamaciones: 'Reclamaciones',
  lb_reclamaciones_descripcion:
    'Si deseas realizar una reclamación o poner de manifiesto cualquier actuación irregular, contacta con nosotros.',
  lb_consultas_sugerencias: 'Consultas y sugerencias',
  lb_consultas: 'Consultas',
  lb_consultas_sugerencias_descripcion:
    'Si deseas realizar alguna otra consulta no dudes en contactarnos rellenando nuestro formulario.',
  lb_entrar: 'Entrar',
  lb_formulario_reclamaciones: 'Formulario de reclamaciones',
  lb_formulario_reclamaciones_info_1:
    'Los datos que nos facilites serán única y exclusivamente utilizados por la EMT a efectos de la reclamación.',
  lb_formulario_reclamaciones_info_2:
    'Por favor, detalla lo más posible todos los datos solicitados para que podamos tramitarla adecuadamente y darte una respuesta concreta a la mayor brevedad.',
  lb_formulario_reclamaciones_info_3:
    'Al pulsar el botón de envío manifiestas haber leído esta información sobre privacidad:',
  lb_formulario_reclamaciones_info_4:
    'El responsable del tratamiento es la Empresa Municipal de Transports Urbans de Palma de Mallorca S.A. (EMT). La finalidad es la valoración, tramitación y registro de la reclamación. Tienes derecho a acceder, rectificar y suprimir los datos, así como otros derechos como se explica en nuestra',
  lb_formulario_reclamaciones_info_5:
    'En caso de aportar datos sensibles (salud, minusvalía, etc.), consientes expresamente a que puedan ser tratados parala atención de la reclamación y el cumplimiento de nuestras obligaciones legales.',
  lb_politica_privacidad: 'Política de privacidad',
  lb_nombre: 'Nombre',
  lb_apellido: 'Apellido',
  lb_telefono: 'Teléfono',
  lb_email: 'Correo electrónico',
  lb_direccion: 'Dirección',
  lb_codigo_postal: 'Código postal',
  lb_municipio: 'Municipio',
  lb_pais: 'País',
  lb_sentido_linea: 'Sentido línea',
  lb_numero_bus: 'Número de bus',
  lb_matricula: 'Matrícula',
  lb_lugar: 'Lugar',
  lb_fecha: 'Fecha',
  lb_hora: 'Hora',
  lb_titulo_transporte: 'Título de transporte',
  lb_numero: 'Número',
  lb_descripcion: 'Descripción',
  lb_enviar: 'Enviar',
  lb_nombre_obligatorio: 'El nombre es obligatorio',
  lb_apellido_obligatorio: 'Los apellidos son obligatorios',
  lb_documento_obligatorio: 'El DNI/NIF/NIE es obligatorio',
  lb_telefono_obligatorio: 'El Teléfono es obligatorio',
  lb_email_invalido: 'Correo electrónico inválido',
  lb_email_obligatorio: 'El correo electrónico es obligatorio',
  lb_lugar_obligatorio: 'El Lugar es obligatorio',
  lb_fecha_obligatorio: 'La fecha es obligatoria',
  lb_descripcion_obligatorio: 'La descripción es obligatoria',
  lb_formulario_consultas: 'Formulario de consultas',
  lb_mensaje: 'Mensaje',
  lb_mensaje_obligatorio: 'El mensaje es obligatorio',
  lb_municipio_obligatorio: 'El municipio es obligatorio',
  lb_titulo_transporte_obligatorio: 'El Título de transporte es obligatorio',
  lb_formulario_consultas_info_1:
    'Recuerda que la mayor parte de la información que puedas necesitar sobre nuestos servicios está contenida en esta web.',
  lb_privacidad_title: 'POLÍTICA DE PRIVACIDAD',
  lb_mas_detalles: 'Más detalles',
  lb_line_view_detail: 'Ver detalle línea',
  lb_alarm_program: 'Programar alarma',
  lb_alarm_bus_select_title: 'Crear alerta llegada bus',
  lb_alarm_bus_select_desc:
    'Al activar la alerta de llegada del bus, recibirás una notificación con tiempo de antelación sobre la llegada de este.',
  lb_alarm_bus_option1: '2 minutos antes',
  lb_alarm_bus_option2: '5 minutos antes',
  lb_alarm_bus_option3: '8 minutos antes',
  lb_alarm_bus_select: 'Tiempo de antelación',
  lb_alarm_bus_notification_title: 'Llegada del bus',
  lb_alarm_next_bus: 'Activar alerta segundo bus',
  lb_formulario_enviado: 'Formulario enviado',
  lb_documento_no_valido: 'El documento no es válido',

  lb_elija_una_opcion: 'Elija una opción',
  lb_tarjeta_ciudadana: 'Tarjeta ciudadana',
  lb_billete: 'Billete',
  lb_otros: 'Otros',

  lb_campos_marcados_con: 'Todos los campos marcados con',
  lb_son_obligatorio: 'son obligatorios.',

  lb_ingresa_captcha: 'Ingresa el captcha',

  lb_salida_refuerzo_desde:'Salidas de refuerzo:',
  lb_desde:'de',
  lb__desde:'de',
  lb_hasta:'a',
  lb_a: 'a',
  lb_volver: 'volver',

  lb_ver_los: 'Ver los',
  lb_articulos: 'articulos',

  lb_paradas_lineas_puntos:'paradas, líneas, puntos de interés...',

  lb_todo:'Todo',

  lb_ver_todas_las:'Ver todas las',
  lb_ver_todos_los:'Ver todos los',
  lb_informacion_consejos_noticias:'información, consejos, noticias',
  lb_ver_todos_los_resultados: 'Ver todos los resultados',

  lb_segundo_bus_en:'segundo bus en',

  lb_otra_informacion: 'Puntos de interés',

  lb_manana:'mañana',
  lb_tarde:'tarde',
  lb_frecuencia_manana:'Frecuencia mañana',
  lb_frecuencia_tarde:'Frecuencia tarde',

  lb_no_hay_resultados:'No hay resultados',
  lb_no_hay_resultados_para: 'No hay resultados para:',
  lb_lineas_y_paradas: 'líneas y paradas',
  lb_buscar_mas: 'Buscar más',

  weekDays: {
    0: 'Domingo',
    1: 'Lunes',
    2: 'Martes',
    3: 'Miercoles',
    4: 'Jueves',
    5: 'Viernes',
    6: 'Sabado',
  },
  weekDaysAbrev: {
    0: 'Dom.',
    1: 'Lun.',
    2: 'Ma.',
    3: 'Mier.',
    4: 'Jue.',
    5: 'Vie.',
    6: 'Sab.',
  },
  months: {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
  },
  monthsAbrev: {
    1: 'En.',
    2: 'Feb.',
    3: 'Mar.',
    4: 'Abr.',
    5: 'May.',
    6: 'Jun.',
    7: 'Jul.',
    8: 'Agos.',
    9: 'Sept.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Dic.',
  },

  lb_selecciona_un_icono:'Selecciona un icono',

  lb_mas_informacion: 'Más información',
  lb_ver_more: 'Ver más',
  lb_cookies_principal_body: 'EMTPalma usa las cookies esenciales, analíticas y de marketing para ofrecer, mantener y mejorar nuestros servicios y anuncios. Si estás de acuerdo, utilizaremos estos datos para la personalización de los anuncios y los análisis asociados.',
  lb_cookies_banner_title: 'Panel de aceptación Cookies',
  lb_cookies_banner_intro1: 'Este es el panel de configuración y aceptación de Cookies.',
  lb_cookies_banner_intro2: 'Selecciona las que deseas aceptar.',
  lb_cookies_banner_technic_title: 'Cookies técnicas',
  lb_cookies_banner_technic_desc: 'Estás cookies permiten controlar el tráfico y la comunicación de datos.',
  lb_cookies_banner_need: 'necesarias',
  lb_cookies_banner_view: 'Ver',
  lb_cookies_banner_hide: 'Ocultar',
  lb_cookies_banner_list_cookies: 'listado detallado de este tipo de cookies.',
  lb_cookies_banner_denomi: 'Denominación',
  lb_cookies_banner_origin: 'Origen',
  lb_cookies_banner_duration: 'Duración',
  lb_cookies_banner_purpose: 'Finalidad',
  lb_cookies_banner_persist: 'Persistente',
  lb_cookies_banner_technic_table_purpose1: 'Identifica si se ha realizado la aceptación de las cookies.',
  lb_cookies_banner_technic_table_purpose2: 'Identifica el último idioma seleccionado por el usuario.',
  lb_cookies_banner_analytics_title: 'Aceptar cookies analíticas',
  lb_cookies_banner_analytics_desc: 'Estas cookies recogen datos sobre el comportamiento de los usuarios y permiten elaborar un perfil de usuario. Google Analytics',
  lb_cookies_banner_analytics_table_purpose1: 'Persistente, dos años a partir de la configuración o actualización.',
  lb_cookies_banner_analytics_table_purpose1_desc: 'Se usa para distinguir a los usuarios.',
  lb_cookies_banner_analytics_table_purpose2_duration: 'Persistente, finaliza al terminar la sesión.',
  lb_cookies_banner_analytics_table_purpose2: 'Incluye información de la campaña relativa al usuario. Si has vinculado tus cuentas de Google Analytics y AdWords, las etiquetas de conversión de sitios web leerán esta cookie, a menos que la inhabilites.',
  lb_cookies_banner_accept_all: 'Aceptar todas',
  lb_cookies_banner_accept_select: 'Aceptar seleccionadas',




  lb_privacidad_body: `<div class="contenidoGeneral">
        <p>Última modificación: noviembre&nbsp;del 2023</p>

        <p>
            Esta política de privacidad se aplica a la presente web (en adelante la Web).
        </p>

        <p>
            Por favor, léala detenidamente. En ella encontrará información importante sobre el tratamiento de sus datos personales y los derechos que le reconoce la normativa vigente en la materia.
        </p>

        <p>
            Nos reservamos el derecho de actualizar nuestra política de privacidad en cualquier momento con motivo de decisiones empresariales, así como para cumplir con eventuales cambios legislativos o jurisprudenciales. Si tiene dudas o necesita cualquier aclaración respecto a nuestra Política de privacidad o a sus derechos, puede contactar con nosotros a través de los canales que se indican más abajo.
        </p>

        <p>
            Usted manifiesta que los datos que nos facilite, ahora o en el futuro, son correctos y veraces y se compromete a comunicarnos cualquier modificación de los mismos. En caso de proporcionar datos de carácter personal de terceros, se compromete a obtener el consentimiento previo de los afectados y a informarles acerca del contenido de esta política.
        </p>

        <p>
            De manera general, los campos de nuestros formularios que son señalados como obligatorios, deberán necesariamente ser cumplimentados para poder tramitar sus solicitudes.
        </p>

        <ul>
            <li>
                <strong>¿Quién es el responsable del tratamiento de sus datos?</strong><br>
                Salvo indicación específica en sentido contrario, el responsable del tratamiento de los datos recogidos en esta Web es la Empresa Municipal de Transports Urbans de Palma, S.A. (en adelante EMT) con domicilio en la calle Josep Anselm Clavé nº5, 07002 Palma (Illes Balears); Tel. 971 21 44 44; DPD:
                <a href="mailto:privacidad@emt.palma.cat">privacidad@emt.palma.cat</a>
            </li>

            <li>
                <strong>¿Qué información personal obtenemos?</strong><br>
                Los datos que tratamos son los que se obtienen:
                <ul>
                    <li>De los formularios que Ud. cumplimente y de las solicitudes que formule en la Web. También tratamos los datos incluidos en las solicitudes y peticiones que recibimos por correo electrónico.</li>
                    <li>De perfiles y analíticas obtenidos a partir de la navegación de usuarios de la Web.</li>
                </ul>
                <br>
                Las categorías de datos que tratamos consisten típicamente en:
                <ul>
                    <li>Datos identificativos y de contacto, incluido título de transporte, DNI o pasaporte;</li>
                    <li>Datos de características personales, tales como idioma y nacionalidad;</li>
                    <li>Datos relacionados con su navegación, por ejemplo la dirección IP desde la cual se conecta a la Web, weblogs, páginas visitadas o acciones realizadas en la Web. Para ello utilizamos cookies y tecnologías similares que pueden implicar el rastreo de su navegación. Más información en nuestra Política de cookies.</li>
                    <li>Otros tipos de datos incluidos por los usuarios en sus consultas, comentarios o reclamaciones.</li>
                </ul>
            </li>

            <li>
                <strong>¿Para qué trataremos sus datos?</strong><br>
                Los datos de nuestros usuarios serán tratados para la gestión de la relación con ellos, la atención a sus solicitudes y consultas, la prestación de nuestros servicios, la administración y la gestión de la seguridad de la web y el cumplimiento de nuestras obligaciones legales. Dichos datos serán igualmente tratados para fines de analíticas y de mejora de la calidad.<br>
                La inclusión, en quejas o reclamaciones, de datos personales relativos a su salud, implica necesariamente su consentimiento para el tratamiento de dichos datos para la atención de la referida reclamación.
            </li>

            <li>
                <strong>¿A quién podemos comunicar sus datos?</strong><br>
                Sus datos sólo serán comunicados a terceros por obligación legal, con su consentimiento o cuando su petición implique tal comunicación.<br>
                Por otra parte, se le informa de que, cuando las circunstancias relativas a la tramitación de una queja o reclamación así lo requiera, los destinatarios de la información personal podrán ser, entre otros, administraciones o entidades públicas, organismos oficiales, procuradores, jueces y tribunales o entidades aseguradoras.
            </li>

            <li>
                <strong>Base jurídica de los tratamientos</strong><br>
                La base para el tratamiento de sus datos es la gestión de la relación jurídica que se establece con Ud., la prestación de los servicios solicitados y el cumplimiento de obligaciones legales, especialmente de la normativa aplicable en materia contable y fiscal.<br>
                Los siguientes tratamientos de basan en la existencia de un interés legítimo:
                <ul>
                    <li>La gestión de la seguridad de la Web se basa en la existencia de nuestro interés legítimo en garantizar la seguridad de nuestros sistemas.</li>
                    <li>La realización de estadísticas y control de calidad se basan en nuestro interés legítimo para evaluar nuestros servicios.</li>
                </ul>
                <br>
                Los siguientes tratamientos se basan en su consentimiento, sin que la retirada de tal consentimiento condicione la prestación de los servicios contratados:
                <ul>
                    <li>La realización de perfiles de navegación en base a la información obtenida a partir de cookies o tecnologías similares.</li>
                </ul>
            </li>

            <li>
                <strong>¿Cuánto tiempo conservaremos sus datos? </strong><br>
                De manera general conservamos sus datos durante la vigencia de la relación que mantiene con nosotros y en todo caso durante los plazos previstos en las disposiciones legales aplicables y durante el tiempo necesario para atender a posibles responsabilidades nacidas del tratamiento. Cancelaremos sus datos cuando hayan dejado de ser necesarios o pertinentes para las finalidades para las cuales fueron recabados. Los logs de acceso a áreas restringidas de la web se cancelarán al mes de su creación. Se cancelará la información relacionada con la navegación, una vez finalizada la conexión web y realizadas las estadísticas.
            </li>

            <li>
                <strong>¿Cuáles son sus derechos?</strong><br>
                Tiene derecho a obtener confirmación de si estamos tratando o no sus datos personales y, en tal caso, acceder a los mismos. Puede igualmente pedir que sus datos sean rectificados cuando sean inexactos o a que se completen los datos que sean incompletos, así como solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines para los que fueron recogidos.<br>
                En determinadas circunstancias, podrá solicitar la limitación del tratamiento de sus datos. En tal caso, sólo trataremos los datos afectados para la formulación, el ejercicio o la defensa de reclamaciones o con miras a la protección de los derechos de otras personas. En determinadas condiciones y por motivos relacionados con su situación particular, podrá igualmente oponerse al tratamiento de sus datos. En este caso, dejaremos de tratar los datos salvo por motivos legítimos imperiosos que prevalezcan sobre sus intereses o derechos y libertades, o para la formulación, el ejercicio o la defensa de reclamaciones.<br>
                Así mismo y bajo ciertas condiciones podrá solicitar la portabilidad de sus datos para que sean transmitidos a otro responsable del tratamiento.<br>
                Puede revocar el consentimiento que hubiese prestado para determinadas finalidades, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.<br>
                Tiene igualmente el derecho a presentar una reclamación ante una autoridad de protección de datos.<br>
                Para ejercer sus derechos deberá remitir una solicitud acompañada de una copia de su documento nacional de identidad, u otro documento válido que le identifique por correo postal o electrónico, a nuestro Delegado de Protección de Datos en las direcciones indicadas en el apartado ¿Quién es el responsable del tratamiento de sus datos?<br>
                Podrá obtener más información sobre sus derechos y cómo ejercerlos en la página de la Agencia Española de Protección de Datos en
                <a href="http://www.aepd.es" target="_blank"><u>www.aepd.es</u></a>.
            </li>
        </ul>

        <p>&nbsp;</p>

        <p>
            <strong>Información a los usuarios sobre la política de privacidad vinculada a la subvención de la gratuidad del bus en la EMT Palma durante el 2023</strong>
        </p>

        <p>
            Se informa a los usuarios del transporte público, clientes y potenciales clientes de los datos personales que podrán recabarse, según se establece en la concesión de una subvención nominativa a la Comunidad Autónoma de las Illes Balears para el establecimiento de un descuento del 100% en el precio de los abonos de transporte y títulos multiviaje del transporte público colectivo terrestre de las Illes Balears del Ministerio de Transportes, Movilidad y Agenda Urbanos para el año 2023. En concreto, podrán recabarse: el identificador del abono, el DNI del usuario del abono, el tiempo de duración, el trayecto o zona cubiertos, y la fecha en que fue expedido. Para los títulos multiviaje: el identificador del título, el itinerario o ámbito territorial de aplicación al cual corresponde el título, el número de viajes que incluye el título y la fecha de expedición, que serán puestas a disposición del Ministerio de Transportes, Movilidad y Agenda Urbana con la única finalidad del control y verificación del cumplimiento de las condiciones que regulan la citada subvención.
        </p>
    </div>
    `,
  lb_aviso_legal_body: `
    <div class="contenidoGeneral">
    <h1>NOTA LEGAL Y CONDICIONES DE USO DE LA WEB</h1>

    <p>&nbsp;</p>

    <p>El acceso a la presente web atribuye la condición de USUARIO e implica la aceptación plena y sin reserva, desde dicho acceso y/o uso, de la presente nota legal y de la política de privacidad en su última versión. Por ello, aconsejamos que proceda a la lectura de estos documentos, antes de utilizar las funcionalidades ofrecidas por este sitio Web, así como cada vez que acceda a él, ya que nos reservamos el derecho de cambiar, modificar, añadir o eliminar en cualquier momento parte de estas condiciones.</p>

    <p>El mero acceso a esta Web no supone en ningún caso la existencia de una relación comercial entre el usuario y la web.</p>

    <p>&nbsp;</p>

    <p><b>I. TITULAR DE LA WEB</b></p>

    <p>A los efectos de lo previsto por el Art. 10 de la Ley 34/ 2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se proporciona la siguiente información sobre la titular de esta Web:</p>

    <ul>
        <li><b>Titular de la Web</b>: Empresa Municipal de Transports Urbans de Palma, S.A. (en adelante, <b>EMT</b>).</li>
        <li><b>Domicilio social</b>: calle Josep Anselm Clavé nº5, 07002 Palma (Illes Balears)</li>
        <li><b>C.I.F. </b>A07152515</li>
        <li><b>Datos registrales</b>: inscrita en el registro Mercantil de Palma, Tomo 534, Libro 45, Folio 70, Sección, Hoja PM8833, Inscripción 17</li>
    </ul>

    <p>Además del domicilio social, se pone a disposición de los usuarios los siguientes canales para dirigir sus peticiones, cuestiones o reclamaciones:</p>

    <ul>
        <li>Formulario de contacto de la web</li>
        <li>Correo electrónico: usuaris@emt.palma.es</li>
        <li>Teléfono: 971 214 444</li>
    </ul>

    <p>&nbsp;</p>

    <p><b>II. CONDICIONES DE USO</b></p>

    <p><b>1. Introducción. </b> La <b>EMT</b> ofrece en esta web información acerca de la red de líneas de transporte urbano colectivo del término municipal de Palma. Accediendo y utilizando esta web, usted acuerda obligarse a las condiciones que a continuación se exponen, por lo que se le recomienda que lea cuidadosamente esta sección antes de iniciar su navegación.</p>

    <p><b>2. Obligaciones de los Usuarios. </b>Los Usuarios se comprometen a utilizar esta Web de forma lícita, de acuerdo con lo dispuesto en las presentes condiciones y de forma que no produzcan un perjuicio en los derechos o intereses de la <b>EMT</b> o de terceros. A título enunciativo y en ningún caso limitativo o excluyente, el Usuario se compromete igualmente a:</p>

    <ul>
        <li>No incurrir en actividades ilegales o contrarias al orden público o a la buena fe;</li>
        <li>No utilizar los datos publicados en la Web para el envío de comunicaciones no solicitadas (spam);</li>
        <li>No introducir o difundir en la web información o contenidos falsos, engañosos, ambiguos o inexactos de forma que induzcan a error a los receptores de la información, ni tampoco difundir contenidos de carácter racista, xenófobo, pornográfico, de apología del terrorismo o atentatorio contra los derechos humanos o de los menores;</li>
        <li>No realizar acciones que supongan o conlleven una violación de los derechos de propiedad intelectual de la <b>EMT</b> o de terceros;</li>
        <li>No provocar daños en los sistemas físicos y lógicos de la <b>EMT</b>, de sus proveedores o de terceras personas;</li>
        <li>No introducir o difundir en la red virus informáticos o utilizar cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar los daños anteriormente mencionados;</li>
        <li>No suprimir, alterar, eludir o manipular cualquier dispositivo de protección o sistema de seguridad que estuviera instalado en las páginas de esta Web.</li>
    </ul>

    <p><b>3. Exclusión de responsabilidad. </b>Esta Web se proporciona “tal como está” y su uso se realiza bajo el propio riesgo del Usuario, por lo que, ni la <strong>EMT</strong>, ni sus administradores, trabajadores, proveedores o colaboradores serán responsables por los daños, de cualquier naturaleza, directos o no, que deriven del uso de la Web, excluyendo expresamente la <strong>EMT</strong>, en toda la medida prevista por la Ley, cualquier tipo de garantías, ya sean expresas o implícitas.</p>

    <p>La <b>EMT</b> no garantiza la disponibilidad y accesibilidad de la Web, si bien realizará todos los esfuerzos que sean razonables en este sentido. En ocasiones, podrán producirse interrupciones por el tiempo que resulte necesario para la realización de las correspondientes operaciones de mantenimiento.</p>

    <p>La <b>EMT</b> no se responsabiliza de posibles daños derivados de interferencias, interrupciones, virus informáticos, averías telefónicas o desconexiones telefónicas motivadas por causas ajenas a la citada entidad; de retrasos o bloqueos en el uso del presente sistema electrónico causados por deficiencias o sobrecargas en el centro procesador de datos, de líneas telefónicas, en el sistema de Internet o en otros sistemas eléctricos; ni tampoco de cualquier otra alteración que se pueda producir en el Software o Hardware de los Usuarios. Tampoco garantiza la ausencia de virus, malwares, troyanos u otros elementos que puedan producir alteraciones en el sistema informático, documentos o ficheros del Usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al Usuario por este motivo. De igual manera, la <b>EMT</b> no responderá por los daños causados por terceras personas mediante intromisiones ilegítimas fuera de su control.</p>

    <p>Tampoco responderá de los daños y perjuicios causados por el uso o mala utilización de los contenidos de la Web, ni por las consecuencias que pudieran derivarse de los errores, defectos u omisiones en los contenidos que pudieran aparecer en esta Web proporcionados por los propios Usuarios u otros terceros. La <b>EMT</b> no asume obligación ni responsabilidad alguna respecto de aquellos servicios que no preste directamente.</p>

    <p><b>4. Enlaces externos. </b>En ningún caso la <b>EMT</b> asumirá responsabilidad alguna por los contenidos de los enlaces pertenecientes a un sitio web ajeno, ni garantizará la disponibilidad técnica, calidad, fiabilidad, exactitud, amplitud, veracidad, validez y legalidad de cualquier material o información contenida en ninguno de dichos hipervínculos u otros sitios de Internet. Igualmente, la inclusión de estas conexiones externas no implicará ningún tipo de asociación, fusión o participación con las entidades conectadas.</p>

    <p><b>5. Tratamiento de datos personales. </b>Los Usuarios consienten el tratamiento de sus datos personales con el alcance y en los términos que se indican en nuestra política de privacidad, la cual está disponible en la página de inicio de la Web, quedando asimismo dicha política incorporada a las presentes condiciones por referencia. En dicha política, los Usuarios encontrarán información sobre la manera de ejercitar sus derechos de acceso, supresión, limitación y rectificación de su información personal, así como el de oposición a su tratamiento y portabilidad.</p>

    <p><b>6. Propiedad intelectual y derechos de autor. </b>Sin perjuicio de los contenidos sobre los cuales terceros ostentasen derechos intelectuales, los derechos de propiedad intelectual de la Web, el nombre de dominio, su código fuente, diseño y estructura de navegación y elementos en ella contenidos (a título enunciativo, imágenes, sonido, audio, vídeo, software, o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, etc.) son titularidad de la <b>EMT</b> , a quien corresponde el ejercicio exclusivo de los derechos de explotación de los mismos en cualquier forma, y, en especial los derechos de reproducción, distribución, comunicación pública y transformación, conforme a lo previsto por la vigente Ley de Propiedad Intelectual. Quedan expresamente prohibidas la reproducción, distribución y la comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta web en cualquier soporte y por cualquier medio técnico, sin la autorización de la <b>EMT</b> o, en su caso, de los terceros que ostenten los derechos de propiedad intelectual o de autor sobre los contenidos afectados. No obstante lo anterior, el usuario de la web podrá visualizar los elementos de esta Web e incluso imprimirlos, copiarlos y almacenarlos en el disco duro de su ordenador o en cualquier otro soporte físico siempre y cuando sea, única y exclusivamente, para su uso personal y privado. Aquellas entidades o personas que, previa autorización del titular de esta web, pretendan establecer un enlace con ella, deberán garantizar que únicamente permite el acceso a esta Web o servicio pero que no realiza reproducción de sus contenidos y servicios.</p>

    <p><b>7. Nulidad de las cláusulas. </b>En caso de que una cláusula de las presentes condiciones de uso fuese declarada nula, sólo afectará a dicha disposición o a aquella parte que así haya sido declarada, subsistiendo las condiciones en todo lo demás y teniéndose tal disposición, o la parte afectada, por no puesta.</p>

    <p><b>8. Aceptación. </b>El acceso a la Web y su utilización implican necesariamente que todas y cada una de las presentes condiciones de uso son expresamente aceptadas por usted.</p>

    <p><b>9. Ley y jurisdicción aplicables. </b>La presente web se regirá por la ley española con exclusión de sus reglas de conflicto de ley y cualquier controversia que pudiera derivarse de su utilización o de los servicios vinculados a la misma se someterá a la jurisdicción de los Juzgados y Tribunales que resulten competentes en cumplimiento de la normativa aplicable.</p>

    <p>La Comisión Europea facilita una plataforma de resolución de litigios en línea dirigida a los consumidores, pudiendo estos acceder a la misma mediante el siguiente enlace: <a href="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.chooseLanguage">https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.chooseLanguage</a></p>

    <p>&nbsp;</p>

    <p>Versión 1.0 – enero 2021</p>
    </div>
    `,
  lb_politica_cookies_body: `
<div class="contenidoGeneral">
    <h1>POLÍTICA DE COOKIES</h1>

    <p><u><b>¿QUÉ SON LAS COOKIES?</b></u></p>
    <p>Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando navega. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerle como usuario, obtener información sobre sus hábitos de navegación o personalizar la forma en que se muestra el contenido.</p>
    <p>Existen cookies que son controladas y gestionadas por el propio titular de la Web (son llamadas “cookies propias”) y otras que lo son por terceros (son conocidas como “cookies de terceros”), por ejemplo, porque estos proporcionan una herramienta o una funcionalidad integrada a la web.</p>
    <p>Los usos concretos que hacemos de estas tecnologías se describen a continuación.</p>

    <p><u><b>¿QUÉ TIPO DE COOKIES UTILIZAMOS Y PARA QUÉ?</b></u></p>
    <p>En esta web utilizamos los siguientes tipos de cookies:</p>

    <ol>
        <li>
            <b>Cookies técnicas o indispensables a la prestación de los servicios:</b>
            <p>Son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan, incluyendo aquellas que se utilizan para permitir la gestión y operativa de la página web y habilitar sus funciones y servicios...</p>
            <ul>
                <li>
                    FACEBOOK: <a href="https://www.facebook.com/policies/cookies/" target="_blank">https://www.facebook.com/policies/cookies/</a>
                </li>
                <li>
                    TWITTER: <a href="https://help.twitter.com/es/rules-and-policies/twitter-cookies" target="_blank">https://help.twitter.com/es/rules-and-policies/twitter-cookies</a>
                </li>
            </ul>
        </li>
        <li>
            <b>Cookies de preferencias o personalización:</b>
            <p>Utilizamos cookies propias que permiten recordar información para que el usuario acceda al servicio con determinadas características...</p>
            <ul>
                <li>
                    Para aceptar o rechazar el uso de este tipo de cookies puede utilizar el <a href="javascript:CookieScript.instance.show()">panel de configuración</a>.
                </li>
            </ul>
        </li>
        <li>
            <b>Cookies de análisis o medición:</b>
            <p>Utilizamos cookies de terceros, que permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico...</p>
            <ul>
                <li>
                    Consulte el listado de los terceros que tratan la información obtenida con estas cookies en el apartado “Cookies de terceros”.
                </li>
                <li>
                    Para aceptar o rechazar el uso de este tipo de cookies puede utilizar el <a href="javascript:CookieScript.instance.show()">panel de configuración</a>.
                </li>
            </ul>
        </li>
        <li>
            <b>Cookies de publicidad comportamental:</b>
            <p>También utilizamos cookies de terceros, que permiten analizar los hábitos de navegación de los usuarios para elaborar perfiles específicos...</p>
            <ul>
                <li>
                    Consulte el listado de los terceros que tratan la información obtenida con estas cookies en el apartado “Cookies de terceros”.
                </li>
                <li>
                    Para aceptar o rechazar el uso de este tipo de cookies puede utilizar el <a href="javascript:CookieScript.instance.show()">panel de configuración</a>.
                </li>
            </ul>
        </li>
    </ol>

    <p><u><b>TRANSFERENCIAS DE DATOS TERCEROS PAÍSES</b></u></p>
    <p>Puede informarse de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas.</p>

    <p><u><b>PERIODO DE CONSERVACIÓN DE LOS DATOS</b></u></p>
    <p>Ciertas cookies se cancelan una vez finalizada la navegación en la web (cookies de sesión) mientras que otras pueden seguir almacenadas en el equipo de los usuarios y ser accedidas por un periodo más largo (cookies persistentes).</p>
    <ul>
        <li>Cookies propias de preferencias o personalización: Se conservan durante un año.</li>
        <li>Caducidad de las cookies de terceros: Puede informarse sobre los periodos de conservación en sus políticas.</li>
    </ul>

    <p><u><b>TRATAMIENTOS DE DATOS PERSONALES Y DERECHOS DEL INTERESADO</b></u></p>
    <p>La instalación de cookies de terceros puede implicar la recogida de datos personales de navegación...</p>

    <p><u><b>¿CÓMO PUEDO GESTIONAR LAS COOKIES?</b></u></p>
    <p>Puede gestionar las cookies mediante el panel de configuración o la configuración de su navegador:</p>
    <ul>
        <li><a href="javascript:CookieScript.instance.show()">Panel de configuración de las cookies</a></li>
        <li>Parámetros del navegador: Puede permitir o bloquear las cookies...</li>
    </ul>

    <p><u><b>COOKIES DE TERCEROS</b></u></p>

    <!-- Tabla responsive -->
    <div style="overflow-x: auto;">
        <table border="1" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 100%; text-align: center;">
            <thead>
                <tr>
                    <th>TIPO DE COOKIES</th>
                    <th>COOKIES</th>
                    <th>RESPONSABLE</th>
                    <th>+ INFO</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Análisis o medición</td>
                    <td>GOOGLE ANALYTICS</td>
                    <td>Google, Inc.<br>1600 Amphitheatre Parkway, Mountain View, CA 94043. EE.UU.</td>
                    <td>
                        <p>Más información:</p>
                        <a href="https://support.google.com/analytics/answer/6004245">https://support.google.com/analytics/answer/6004245</a>
                        <a href="http://www.google.com/intl/es/policies/privacy/">http://www.google.com/intl/es/policies/privacy/</a>
                    </td>
                </tr>
                <tr>
                    <td>Análisis o medición</td>
                    <td>JSESSIONID</td>
                    <td>Adobe Systems Software Ireland Limited<br>6 Riverwalk, Naas Road, Dublín 24, Irlanda</td>
                    <td>
                        <p>Más información:</p>
                        <a href="https://www.adobe.com/es/privacy/cookies.html">https://www.adobe.com/es/privacy/cookies.html</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

    `,
};
